export const standardsCatalogueData = [
  {
    "code": "MS 74:2014",
    "title": "Pasteurized cow’s milk – Specification (2nd Edition) (COMESA harmonized)",
    "description": "Applies to pasteurized cow’s milk",
    "sector": "",
    "date_gazetted": "29th September 2017 (Government Notice No. 50)",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 542:2014",
    "title": "Sorghum grains – Specification, (2nd Edition) (COMESA Harmonized)",
    "description": "Applies to sorghum grains for human consumption; i.e. ready for its intended use as human food presented in packaged form or sold loose from the package directly to the consumer. It does not apply to other products derived from sorghum grains.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 619:2016",
    "title": "Fruit juices and nectars – Specification (2nd Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for fruit juices, fruit nectars and concentrated fruit juices intended for direct human consumption or for further processing",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 631:2016",
    "title": "Corned Beef – Specification (2nd Edition) (COMESA Harmonized)",
    "description": "Applies to canned beef products designated as \"Corned beef\" and sold in hermetically sealed containers which have been heat treated after sealing to such an extent that the product is shelf-stable. It does not apply to meat products of the type \"Corned beef\" with compositional characteristics different from those specified.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 807:2014",
    "title": "Luncheon Meat (2nd Edition) (COMESA Harmonized)",
    "description": "Applies to products designated as “Luncheon meat” which have been packed in any suitable packing material.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 839 :2013",
    "title": "Quick frozen shrimps or prawns –Specification (1st Edition) (COMESA Harmonized)",
    "description": "Provides requirements for quick frozen raw or partially or fully cooked shrimps or prawns peeled or unpeeled.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 929:2015",
    "title": "Broadleaved sawn timber – Nominal sizes (1st Edition) (COMESA Harmonized)",
    "description": "Specifies nominal sizes of unplaned, square-edged and unedged, broadleaved sawn timber.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 931:2015",
    "title": "Cast carbon steels for general engineering purposes (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for eight grades of heat-treated cast carbon steels for general engineering purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 933-2:2015",
    "title": "Stainless steels for general purposes - Part 2: Corrosion resistant Semi-finished products, bars, rods and sections (1st Edition) (COMESA Harmonized)",
    "description": "Specifies technical delivery conditions for semi-finished products, hot formed bars, rods, and sections for general purposes made of the most important corrosion-resistant stainless steel grades.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 933-3:2015",
    "title": "Stainless steels for general purposes – Specification - Part 3: Wire (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for stainless steel wire for common use for which no product standard exists. It includes round, flat and shaped wire (such as square, hexagonal or rectangular wire), made of the most commonly used types of stainless steels for general corrosion resistance and high-temperature service. The wire may be supplied in coils or in straightened and cut lengths.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 939:2016",
    "title": "Labelling of and claims for food special for medical purposes (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the labelling of and claims for foods for special medical purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 941:2016",
    "title": "General Standard for the labelling of and claims for pre-packaged foods for special dietary uses (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the labelling of and claims for pre-packaged foods for special dietary uses.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 943:2016",
    "title": "Formula Foods for Use in Weight Control Diets (1st Edition) (COMESA Harmonized)",
    "description": "Applies to formula foods for use in weight control diets and presented as such. It does not apply to pre-packaged meals controlled in energy and presented in the form of conventional foods.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-1:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 1: Application, ratings and performance (1st Edition) (COMESA Harmonized)",
    "description": "Defines various classifications for the application, rating and performance of generating sets consisting of a Reciprocating Internal Combustion (RIC) engine, Alternating Current (a.c.) generator and any associated control gear, switchgear and auxiliary equipment.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-2:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 2: Engines (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the principal characteristics of a reciprocating Internal Combustion (RIC) engine when used for alternating current (a.c) generating set applications.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-3:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 3: Alternating current generators for generating sets (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the principal characteristics of Alternating Current (a.c) generators under the control of their voltage regulators when used in generating set applications.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-4:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 4: Control gear and switch gear (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the criteria for control gear and switchgear for generating sets with reciprocating internal combustion engines.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-5:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 5: Generating sets (1st Edition) (COMESA Harmonized)",
    "description": "Defines terms and specifies design and performance criteria arising out of the combination of a Reciprocating Internal Combustion (RIC) engine and an Alternating Current (a.c.) generator when operating as a unit.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-7:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 7: Technical declarations for specification and design (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements and parameters for the specification and design of a reciprocating internal combustion (RIC) engine driven generating set.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-8:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 8: Requirements and tests for low-power generating sets (1st Edition) (COMESA Harmonized)",
    "description": "Defines requirements, minimum performances and type tests for low-power generating sets driven by reciprocating internal combustion engines for land and marine use (domestic, recreational and industrial application), excluding generating sets used on aircraft.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 949-12:2015",
    "title": "Reciprocating internal combustion engine driven alternating current generating sets – Part 12: Emergency power supplies to safety services (1st Edition) (COMESA Harmonized)",
    "description": "This part of MS 949 applies to generating sets driven by reciprocating internal-combustion (WC) engines for emergency power supply to safety services.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 965-1:2015",
    "title": "Steel for the pre-stressing of concrete - Part 1: General requirements (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for high tensile strength steel to be used in prestressed concrete. It applies only to material in the condition as supplied by the manufacturer. It does not cover requirements for materials and anchorage devices used in conjunction with’ the prestressing steel in structural components.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 965-2:2015",
    "title": "Steel for the pre-stressing of concrete - Part 2: Cold drawn wire (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for round, cold-drawn, high-tensile steel wire, either plain, indented, ribbed or crimped. The product is supplied as mill coil wire or straightened and stress-relieved wire in coils or cut lengths, according to the general requirements specified in MS 965-1.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 965-3:2015",
    "title": "Steel for the pre-stressing of concrete – Part 3: Quenched and tempered wire (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for round wire made of quenched and tempered high tensile steel, with a surface which is plain, ribbed, grooved or indented. The product is delivered in coils, according to the general requirements specified in MS 965-1.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 965-4:2015",
    "title": "Steel for the pre-stressing of concrete – PPart 4: Strand (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for high tensile steel strand which has been given a stress relieving heat treatment according to the general requirements specified in MS 965-1. The strand may contain 2, 3, 7 or 19 individual wires.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 965-5:2015",
    "title": "Steel for the pre-stressing of concrete – Part 5: Hot-rolled steel bars with or without subsequent processing (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for round high tensile steel bars. The bars may be supplied either hot-rolled or in a hot-rolled and processed condition, according to the general requirements specified in MS 965-1. The surface may be plain or ribbed.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1000:2014",
    "title": "Certain pulses - Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the whole, shelled or split pulses (beans, lentils, peas, chick peas, filed beans and cow peas) which are intended for direct human consumption. The Standard does not apply to pulses intended for factory grading and packaging, industrial processing, or to those pulses intended for use in the feeding of animals. It does not apply to fragmented pulses when sold as such, or to other legumes for which separate standards may be elaborated.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1003:2014",
    "title": "Papayas – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to fruits of commercial varieties of papayas grown from Carica papaya L., of the Caricaceae family, to be supplied fresh to the consumer, after preparation and packaging. Papayas for industrial processing are excluded.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1004: 2014",
    "title": "Mangoes – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to commercial varieties of Mangoes grown from Mangifera indica L., of the Anacardiaceae family, to be supplied fresh to the consumer, after preparation and packaging. Mangoes for industrial processing are excluded.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1005:2014",
    "title": "Dates – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to commercially prepared whole dates in pitted or un-pitted styles packed ready for direct consumption. It does not apply to other forms such as pieces or mashed dates or dates intended for industrial purposes",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1006:2014",
    "title": "Milk fat products (1st Edition) (COMESA Harmonized)",
    "description": "Applies to anhydrous milkfat, milkfat, anhydrous butteroil, butteroil and ghee, which are intended for further processing or culinary use.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1060:2015",
    "title": "Steel wire ropes for lifts – Minimum requirements (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the minimum requirements for the manufacture and testing of stranded carbon steel wire ropes used for suspension duty on traction drive and roped hydraulic lifts, and for compensation and governor duties on passenger and freight lifts, dumbwaiters, personnel hoists and man lifts moving between guides. It gives the minimum breaking forces for the more common sizes, rope grades and rope classes and constructions.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1061:2015",
    "title": "Steel wire ropes for general purposes – Minimum requirements (1st Edition) (COMESA Harmonized)",
    "description": "Specifies minimum requirements for the manufacture and testing of stranded steel wire ropes for general purposes, including lifting equipment such as cranes and hoists.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1063:2015",
    "title": "Continuous hot-dip zinc-coated carbon steel sheet of structural quality – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to continuous hot dip zinc and zinc iron alloy coated carbon steel sheet of structural quality.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1064:2015",
    "title": "Cold-reduced steel sheet of structural quality – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to cold-reduced steel sheet of structural quality in grades CR220, CR250, CR320 and CH550, usually without the use of microalloying elements. The product is intended for structures that may include bolting, riveting and welding. It is generally used in the delivered condition for fabricating purposes, such as bending, forming or welding.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1065-1:2015",
    "title": "Cold-formed welded structural hollow sections of non-alloy and fine grain steels, Part 1: Technical delivery conditions (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the technical delivery requirements for cold-formed welded structural hollow sections of circular, square or rectangular form. It is applicable to structural hollow sections formed cold without subsequent heat treatment.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1065-2:2015",
    "title": "Cold-formed welded structural hollow sections of non-alloy and fine grain steels, Part 2: Dimensions and sectional properties (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the tolerances for cold-formed welded circular, square and rectangular structural hollow sections, and gives the dimensions and sectional properties for a range of standard sizes",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1066:2015",
    "title": "Hot-rolled steel sheet of structural quality - Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to hot-rolled steel sheet of structural quality usually prepared without the use of microalloying elements. The product is intended for structural purposes where particular mechanical properties are required. It is generally used in the delivered condition and is intended for bolted, riveted or welded structures. This product is produced on a wide strip mill, not a plate mill.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1071:2015",
    "title": "Cold-reduced carbon steel sheet of commercial and drawing qualities (1st Edition) (COMESA Harmonized)",
    "description": "Applies to cold-reduced carbon steel sheet of commercial and drawing qualities. It is suitable for applications where the surface is of prime importance.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1072:2015",
    "title": "High strength cast steels for general engineering and structural purposes (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for four grades of heat-treated cast carbon and alloy steels for general engineering and structural purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1075:2015",
    "title": "Stainless steel tubes – Dimensions, tolerances and conventional masses per unit length (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the diameters, thicknesses, tolerances and conventional masses per unit length of stainless steel tubes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1076:2015",
    "title": "Hot dip galvanized coatings on fabricated iron and steel articles – Specifications and test methods (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the general properties of coatings and test methods for coatings applied by dipping fabricated iron and steel articles (including certain castings) in a zinc melt (containing not more than 2 % of other metals).",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1077:2015",
    "title": "Round non-alloy steel wires for stranded wire ropes for mine hoisting – Specifications (1st Edition) (COMESA Harmonized)",
    "description": "Specifies round non-alloy steel drawn wires to be used in the manufacture of stranded wire ropes for mine hoisting.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1078:2015",
    "title": "Hot-rolled steel strip of structural quality – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements for hot-rolled steel strip",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1080:2015",
    "title": "Cold-reduced carbon steel sheet according to hardness requirements (1st Edition) (COMESA Harmonized)",
    "description": "Applies to cold-reduced carbon steel sheet and corresponding hardness requirements. It is suitable for applications where the surface is of prime importance.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1097-1:2016",
    "title": "Cold-formed welded structural hollow sections of non-alloy and fine grain steels — Part 1: Technical delivery conditions (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the technical delivery requirements for cold-formed welded structural hollow sections of circular, square or rectangular form. It is applicable to structural hollow sections formed cold without subsequent heat treatment.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1097-2:2016",
    "title": "Cold-formed welded structural hollow sections of non-alloy and fine grain steels — Part 2: Dimensions and sectional properties (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the tolerances for cold-formed welded circular, square and rectangular structural hollow sections, and gives the dimensions and sectional properties for a range of standard sizes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1098-1:2015",
    "title": "Structural steels — Part 1: Technical delivery conditions for structural steels for general purposes (COMESA Harmonized)",
    "description": "Specifies the general technical delivery conditions for steel flat and long products (plate/ sections/wide flats and bars) used principally for general-purpose structural steels..",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1098-2:2015",
    "title": "Structural steels – Part 2: Technical delivery equipment for hot-finished hollow sections (1st Edition) (COMESA Harmonized)",
    "description": "Specifies qualities for steels for general structural use.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1099:2016",
    "title": "Cold-reduced steel sheet of higher yield strength with improved formability (1st Edition) (COMESA Harmonized)",
    "description": "Applies to all grades of cold-rolled steel sheet of higher yield strength with improved formability. The steel is made according to fine-grain practice and has a suitable chemical composition, including microalloying elements, to provide improved formability. The product is intended for the fabrication of parts requiring better formability. It is generally used in the delivered condition.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1100:2016",
    "title": "Steel wire ropes – Vocabulary, designation and classification (1st Edition) (COMESA Harmonized)",
    "description": "Defines terms, and specifies a designation system and a classification system, for steel wire ropes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1102:2016",
    "title": "Steels for general engineering purposes (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the qualities of general purpose steel intended for engineering purposes. This standard applies to hot-rolled steel sheet 3 mm or more thick, flats and bars generally used in the delivered state and as a rule in engineering structures",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1103:2016",
    "title": "Continuous hot-dip terne (lead alloy) coated cold-reduced carbon steel sheet of commercial drawing and structural qualities (1st Edition) (COMESA Harmonized)",
    "description": "Is applicable to cold-reduced carbon steel sheet of commercial, drawing, and structural qualities coated by a continuous hot-dip terne (lead alloy) coating process.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1104:2016",
    "title": "Structural steels with improved atmospheric corrosion resistance (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the chemical and mechanical characteristics, methods of manufacture, the acceptance conditions and the marking of structural steel products possessing improved atmospheric corrosion resistance.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1105:2016",
    "title": "Cold-reduced steel sheet of high tensile strength and low yield point with improved formability – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to killed cold-reduced steel sheet of two types that are commercially available in the world. Type 1 (Table 1) represents steels that are produced to mechanical properties only and Type 2 (Table 2) are produced to both mechanical and chemical properties.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1106:2016",
    "title": "Fasteners – Hot dip galvanized coatings – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies material, process, dimensional and some performance requirements for hot dip spun galvanized coatings applied to coarse threaded steel fasteners from M8 up to and including M64 and for property classes up to and including 10.9 for bolts, screws and studs and 12 for nuts. It is not recommended to hot dip galvanize threaded fasteners in diameters smaller than M8 and/or with pitches below 1.25 mm.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1107:2016",
    "title": "Hot-rolled and cold-reduced electrolytic zinc-coated carbon steel sheet of commercial and drawing qualities – Specification(1st Edition) (COMESA Harmonized)",
    "description": "Specifies the characteristics of carbon steel sheet of commercial and drawing qualities in cut length or coil form, zinc coated by electrolytic deposition.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1109:2016",
    "title": "Continuous electrolytic tin-coated cold-reduced carbon steel sheet of commercial and drawing qualities (1st Edition) (COMESA Harmonized)",
    "description": "Applies to cold-reduced carbon steel sheet of commercial and drawing qualities coated in coil or cut length forms by electro-deposition of tin. The product is commonly known as electrolytic tin-coated sheet and is used where solderability is desired, appearance is important, or a degree of corrosion resistance under specific conditions is advantageous and coating mass can be specified.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1110:2014",
    "title": "Dried apricots – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to dried fruits of Armeniaca Vulgaria Lam. (Prunus armeniaca L.) which have been suitably treated and processed and which are offered for direct consumption. It also covers dried apricots which are packed in bulk containers and which are intended for repacking into consumer size containers or direct sale to consumers/",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1111:2014",
    "title": "Baby Corn – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the cobs, without the silk and anthers, of commercial varieties of baby corn (corn inflorescence) grown from Zea mays L, of the Gramineae family, separated from silk, husk and anthers, to be supplied fresh to the consumer, after preparation and packaging. Baby corn for industrial processing is excluded.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1244:2016",
    "title": "Canned Shrimps or Prawns – Specification (1st Edition) (COMESA Harmonized).",
    "description": "Applies to canned shrimps or canned prawns. It does not apply to specialty products where shrimp constitutes less than 50 % m/m of the contents.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1245:2016",
    "title": "Canned Tuna and Bonito – Specification (1st Edition) (COMESA Harmonized.",
    "description": "Applies to canned tuna and bonito. It does not apply to speciality products where the fish content constitutes less than 50 % m/m of the contents.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1246:2016",
    "title": "Quick frozen blocks of fish fillet, minced fish flesh and mixtures of fillets and minced fish flesh – Specification (1st Edition) (COMESA Harmonized.",
    "description": "Applies to quick frozen blocks of cohering fish flesh prepared from fillets (including pieces of fillets) or minced fish flesh or a mixture of fillets and minced fish flesh, which are intended for further processing.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1248:2016",
    "title": "Table olives – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the fruit of the cultivated olive tree which has been suitably treated or processed, and which is offered for direct consumption as table olives, including for catering purposes or olives packed in bulk containers which are intended for repacking into consumer size containers. It does not apply to the product when indicated as being intended for further processing.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1249:2016",
    "title": "Sardine and sardine type products – Specification (1st Edition) (COMESA Harmonized).",
    "description": "Applies to canned sardines and sardine-type products packed in water or oil or other suitable packing medium. It does not apply to speciality products where fish content constitute less than 50 % m/m of the net contents of the can.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1263:2015",
    "title": "Couscous – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to processed couscous destined for direct human Consumption and it does not apply to couscous intended for the same use but prepared from cereals other than durum wheat.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1265:2016",
    "title": "Cooked cured ham – Specification (COMESA Harmonized)",
    "description": "Applies to products designated as “cooked ham” packaged in any suitable packaging material",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "Ms 1304:2016",
    "title": "Leather – Bovine wet blue – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements, methods of sampling test for wet blue leather produced from bovine hides and parts of bovine hides tanned without hair and with the use of basic chromium sulphate as the primary tanning agent.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1305:2016",
    "title": "Leather – Wet blue sheep skins – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements, methods of sampling and methods of test for wet blue leather produced from sheep skins tanned without wool and with the use of basic chromium sulphate as the primary tanning agent.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1306:2016",
    "title": "Leather – Wet blue goat skins – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies requirements, methods of sampling and methods of test for wet blue leather produced from goat skins tanned without hair and with the use of basic chromium sulphate as the primary tanning agent.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1348:2016",
    "title": "Quick frozen Broccoli – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to quick frozen broccoli of the species Brassica oleracea L. Var. talic Plenck (sprouting broccoli), as defined below and offered for direct consumption without further processing, except for re-packing, if required. It does not apply to the product when indicated as intended for further processing or for other industrial purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1350:2016",
    "title": "Code of hygienic practice for dried fruits (1st Edition) (COMESA Harmonized)",
    "description": "Applies to all fruits that have been dried by natural or artificial means or a combination of both. The fruit is dried to the extent that the greater part of the moisture has been removed, and in addition the fruit may be subjected to a safe and appropriate treatment in preparation and packing, to permit marketing in normal trade channels. Fruits covered by this code include apples, apricots, peaches, pears, nectarines, prunes, figs, dates, and vine fruits such as raisins and currants",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1351:2016",
    "title": "Quick frozen strawberries – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to quick frozen strawberries (excluding quick frozen strawberry puree) of the species Fragaria grandiflora L. And Fragaria vesca L. And offered for direct consumption without further processing, except for size grading or repacking if required. It does not apply to the product when indicated as intended for further processing or for other industrial purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1352:2016",
    "title": "Canned strawberries – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Specifies the requirements and methods of sampling and test for canned strawberries",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1353:2016",
    "title": "Quick frozen cauliflower – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to quick frozen cauliflower of the species Brassica oleracea L. Var. Botrytis L. And offered for direct consumption without further processing, except for repacking, if required. It does not apply to the product when indicated as intended for further processing or for industrial purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1354:2016",
    "title": "Code of hygienic practice for dehydrated fruits and vegetables including edible fungi (1st Edition) (COMESA Harmonized)",
    "description": "Applies to fruits and vegetables which are artificially dehydrated (including freeze-dried), either from the succulent stage or in combination with sun-drying, and covers the products commonly associated with the phrase “dehydrated food”.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1355:2016",
    "title": "Quick frozen peas – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to quick frozen peas of the species Pisum sativum L. As defined below and offered for direct consumption without further processing, except for size grading or repacking if required. It does not apply to the product when indicated as intended for further processing, or for other industrial purposes.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1357:2016",
    "title": "Cocoa butter confectionery – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to the homogeneous product prepared from cocoa butter, milk products and sugars and additions provided for in the standard.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1358:2016",
    "title": "Quick frozen French fried potatoes – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to quick frozen French fried potatoes which have been prepared from tubers of the species Solanum tuberosum L. And offered for direct consumption without further processing except for repacking if required.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1360:2016",
    "title": "Desiccated coconut – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to desiccated coconut, the dried product prepared for human consumption without requiring further processing which is obtained by shredding or otherwise comminuting the pared kernel of coconuts, the fruit of the palm, Cocos nucifera.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1403:2016",
    "title": "Canned crab meat – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to canned crab meat. It does not apply to specialty products where crab meat constitutes less than 50 % m/m of the contents.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  },
  {
    "code": "MS 1405:2016",
    "title": "Dried Shark Fins – Specification (1st Edition) (COMESA Harmonized)",
    "description": "Applies to dried shark fins intended for further processing.",
    "sector": "",
    "date_gazetted": " ",
    "status": "",
    "pages": ""
  }
];
